import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import dispatcher from 'mewe/dispatcher';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import FollowingApi from 'mewe/api/following-api';
import { addObserver, removeObserver } from '@ember/object/observers';
import { installDropdown } from 'mewe/utils/dropdown-utils';

export default class ProfileMainCover extends Component {
  @service dynamicDialogs;
  @service router;
  @service account;

  @tracked dropdownOptions;

  constructor() {
    super(...arguments);
    installDropdown(this, 'dropdownOptions');
    addObserver(this, 'args.contact.id', this.contactChanged);
  }

  willDestroy() {
    super.willDestroy(...arguments);
    removeObserver(this, 'args.contact.id', this.contactChanged);
  }

  contactChanged() {
    this.setDropdownRef(false);
  }

  get isUserFavorite() {
    return this.account.favorites?.includes(this.args.contact.id);
  }

  get isMuteOptionDisabled() {
    return this.isUserFavorite;
  }

  // observer profile and reset state on change

  @action
  toggleFavoriteUser() {
    const user = this.args.contact;

    if (this.isUserFavorite) {

      dispatcher.dispatch('contact', 'removeUserFromFavorite',
        user,
        () => user.set('favorite', false),
        () => user.set('favorite', true)
      );

    } else {
      if (user.muted) {
        this.toggleMutedFeed.perform();
      }

      dispatcher.dispatch('contact', 'addUserToFavorite',
        user,
        () => user.set('favorite', true),
        () => user.set('favorite', false)
      );
    }
  }

  @task
  *toggleMutedFeed() {
    if (this.isMuteOptionDisabled) {
      return;
    }

    if (this.args.contact.muted) {
      yield FollowingApi.removeMute(this.args.contact.id);
      this.args.contact.set('muted', false);
    } else {
      yield FollowingApi.makeMute(this.args.contact.id);
      this.args.contact.set('muted', true);
    }
  }

  @action
  inviteUserToGroup() {
    dispatcher.dispatch('contact', 'addUserToGroup', this.args.contact);
  }

  @action
  removeFollower() {
    dispatcher.dispatch('contact', 'removeFollower', this.args.contact);
  }

  @action
  reportUser() {
    dispatcher.dispatch('contact', 'reportUser', this.args.contact);
  }

  @action
  blockUser() {
    dispatcher.dispatch('contact', 'blockUser', this.args.contact, () => this.router.transitionTo('app.myworld'));
  }

  @action
  shareProfile() {
    this.args.shareProfile?.();
  }

  @action
  editProfileBio() {
    this.dynamicDialogs.openDialog('about-profile-dialog');
  }
}
